/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Footer_FreeInputs */

const en_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People you invite get 300 coins. Upgrade to Plus to give them EXTRA 30 Time Crystals.`)
};

const ar_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يحصل الأشخاص الذين تدعوهم على 300 عملة. قم بالترقية إلى Plus لتمنحهم 30 بلورة زمنية إضافية.`)
};

const de_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von dir eingeladene Personen erhalten 300 Münzen. Upgrade auf Plus, um ihnen 30 zusätzliche Zeitkristalle zu schenken.`)
};

const es_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las personas que invites reciben 300 monedas. Mejora a Plus para darles 30 Cristales de Tiempo extra.`)
};

const fr_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les personnes que vous invitez reçoivent 300 pièces. Passez à Plus pour leur offrir 30 Cristaux de Temps supplémentaires.`)
};

const it_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le persone che inviti ricevono 300 monete. Passa a Plus per dare loro 30 Cristalli del Tempo extra.`)
};

const ja_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`招待した人は300コインを獲得できます。Plusにアップグレードすると、さらに30個のタイムクリスタルを贈れます。`)
};

const ko_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초대한 사람은 코인 300개를 받아요. Plus로 업그레이드하면 시간 크리스탈 30개를 추가로 줄 수 있어요.`)
};

const pt_br_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As pessoas que você convidar ganham 300 moedas. Assine o Plus para dar a elas mais 30 Cristais do Tempo.`)
};

const ru_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приглашенные вами люди получают 300 монет. Перейдите на Plus, чтобы подарить им еще 30 Кристаллов времени.`)
};

const th_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คนที่คุณเชิญจะได้รับ 300 เหรียญ อัปเกรดเป็น Plus เพื่อมอบคริสตัลเวลาเพิ่มอีก 30 ชิ้นให้พวกเขา`)
};

const tr_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet ettiğin kişiler 300 jeton alır. Onlara ekstra 30 Zaman Kristali vermek için Plus’a yükselt.`)
};

const zh_cn_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你邀请的人可获得 300 金币。升级 Plus，再送他们额外 30 颗时光宝石。`)
};

const zh_tw_invite_footer_free = /** @type {(inputs: Invite_Footer_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你邀請的人可獲得 300 金幣。升級 Plus，再送他們額外 30 顆時光寶石。`)
};

/**
* | output |
* | --- |
* | "People you invite get 300 coins. Upgrade to Plus to give them EXTRA 30 Time Crystals." |
*
* @param {Invite_Footer_FreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_footer_free = /** @type {((inputs?: Invite_Footer_FreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Footer_FreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_footer_free(inputs)
	if (locale === "ar") return ar_invite_footer_free(inputs)
	if (locale === "de") return de_invite_footer_free(inputs)
	if (locale === "es") return es_invite_footer_free(inputs)
	if (locale === "fr") return fr_invite_footer_free(inputs)
	if (locale === "it") return it_invite_footer_free(inputs)
	if (locale === "ja") return ja_invite_footer_free(inputs)
	if (locale === "ko") return ko_invite_footer_free(inputs)
	if (locale === "pt_br") return pt_br_invite_footer_free(inputs)
	if (locale === "ru") return ru_invite_footer_free(inputs)
	if (locale === "th") return th_invite_footer_free(inputs)
	if (locale === "tr") return tr_invite_footer_free(inputs)
	if (locale === "zh_cn") return zh_cn_invite_footer_free(inputs)
	return zh_tw_invite_footer_free(inputs)
});